module.exports = __webpack_public_path__ + "static/img/dipan.0274d896.svg";